import React, { useState } from "react";
import styles from "./PubliacionImageView.module.css";
import commentIcon from "../../assets/message.png";
import likeIcon from "../../assets/premium.png";
import medallaTrue from "../../assets/medallaTrue.png";
import userIcon from "../../assets/iconUser.png";
import { formatoFechaLarga, formFecha } from "../../utils/funciones";
import send from "../../assets/send.svg";
import Comentarios from "../../sharedComponents/Comentarios/Comentarios";
import AgregarComentario from "../../sharedComponents/AgregarComentario/AgregarComentario";

const PubliacionImageView = ({
  img,
  onClose,
  publicacion,
  user,
  postComentario,
  mensaje,
  setMensaje,
}) => {
  const [activeTab, setActiveTab] = useState("comentarios");

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <button className={styles.closeBtn} onClick={onClose}>
          X
        </button>
        <div className={styles.contentContainer}>
          <img
            src={img}
            alt="Imagen de la publicación"
            className={styles.bigImg}
          />
          <div className={styles.sidePanel}>
            <div className={styles.tabs}>
              <div
                className={
                  activeTab === "comentarios"
                    ? styles.tabIconContainerActive
                    : styles.tabIconContainer
                }
                onClick={() => setActiveTab("comentarios")}
              >
                <img
                  src={commentIcon}
                  alt="Comentarios"
                  className={styles.tabIcon}
                />
              </div>
              <div
                className={
                  activeTab === "aplausos"
                    ? styles.tabIconContainerActive
                    : styles.tabIconContainer
                }
                onClick={() => setActiveTab("aplausos")}
              >
                <img src={likeIcon} alt="Aplausos" className={styles.tabIcon} />
              </div>
              <div
                className={
                  activeTab === "medallas"
                    ? styles.tabIconContainerActive
                    : styles.tabIconContainer
                }
                onClick={() => setActiveTab("medallas")}
              >
                <img
                  src={medallaTrue}
                  alt="Medallas"
                  className={styles.tabIconM}
                />
              </div>
            </div>
            <div className={styles.tabContent}>
              <div className={styles.contInfo}>
                <img
                  src={publicacion.foto || userIcon}
                  alt="user"
                  className={styles.foto}
                />
                <div className={styles.contInfoUserTxt}>
                  <h3 className={styles.nombre}>{publicacion.nombre}</h3>
                  <p className={styles.fecha}>
                    {formatoFechaLarga(publicacion.fecha)}
                  </p>
                </div>
              </div>
              {activeTab === "comentarios" && (
                <div className={styles.comentarios}>
                  <div className={styles.contComentarios}>
                    {publicacion.comentarios &&
                    publicacion.comentarios.length > 0 ? (
                      [...publicacion.comentarios]
                        .sort(
                          (a, b) =>
                            new Date(b.createdAt) - new Date(a.createdAt)
                        )
                        .map((comentario) => (
                          <Comentarios
                            key={comentario.id}
                            id={comentario.id}
                            usuario={comentario.Usuario}
                            fecha={comentario.createdAt}
                            contenido={comentario.contenido}
                            estrellasBool={false}
                          />
                        ))
                    ) : (
                      <p className={styles.noComent}>No hay comentarios.</p>
                    )}
                  </div>
                  <AgregarComentario
                    user={user}
                    mensaje={mensaje}
                    setMensaje={setMensaje}
                    postComentario={postComentario}
                    valor={null}
                    setValor={null}
                    estrellasBool={false}
                  />
                </div>
              )}
              {activeTab === "aplausos" && (
                <div className={styles.aplausos}>
                  <div className={styles.contAplausosList}>
                    {publicacion.aplausos && publicacion.aplausos.length > 0 ? (
                      publicacion.aplausos.map((aplauso, idx) => (
                        <div className={styles.contAplauso} key={idx}>
                          <img
                            className={styles.fotoAplauso}
                            src={aplauso.Usuario?.foto || userIcon}
                            alt=""
                          />
                          <span className={styles.aplausoTxt}>
                            {aplauso.usuarioNombre}
                          </span>
                        </div>
                      ))
                    ) : (
                      <p className={styles.noComent}>No hay aplausos.</p>
                    )}
                  </div>
                </div>
              )}
              {activeTab === "medallas" && (
                <div className={styles.medallas}>
                  <div className={styles.contAplausosList}>
                    {publicacion.likes && publicacion.likes.length > 0 ? (
                      publicacion.likes.map((medalla, idx) => (
                        <div className={styles.contAplauso} key={idx}>
                          <img
                            className={styles.fotoAplauso}
                            src={medalla.Usuario?.foto || userIcon}
                            alt=""
                          />
                          <span className={styles.aplausoTxt}>
                            {medalla.usuarioNombre}
                          </span>
                        </div>
                      ))
                    ) : (
                      <p className={styles.noComent}>No hay medallas.</p>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PubliacionImageView;
